module.exports = __webpack_public_path__ + "img/08_Howto-4.42177943.jpg";